import React from "react";
import "./Botao.css";

export const Botao = ({nome, icon, link}) => {
    return(
        <a href={link} style={{textDecorationLine: "none"}}>
            <button className="botao">
                <img src={icon} alt="icone"/>
                <div>
                    <p>{nome}</p>
                </div>
            </button>
        </a>
    )
}